import * as React from 'react';

import Checkmark16 from './Checkmark16';

export const checkmark16 = () => <Checkmark16 />;

export default {
    title: 'Icon|Fill|Checkmark16',
    component: Checkmark16,
    parameters: {
        notes: "`import Checkmark16 from 'box-ui-elements/es/icon/fill/Checkmark16';`",
    },
};
